import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import AuditCta from "@/components/AuditCta";

export default function NotFoundPage() {
  return (
    <main className="px-6 sm:px-8 py-28 min-h-[60vh] flex items-center" data-testid="not-found-page">
      <Seo
        title="Page not found"
        description="That page does not exist. Head back to the home page or book a free sales audit."
        path="/404"
        noindex
      />
      <div className="max-w-xl mx-auto text-center">
        <p className="font-fraunces font-extrabold text-sm text-[#C8703A] tracking-[0.2em]">404</p>
        <h1 className="mt-4 font-fraunces font-extrabold text-4xl sm:text-5xl tracking-tight text-[#1F1F1C] leading-tight" data-testid="not-found-heading">
          That page has moved on.
        </h1>
        <p className="mt-6 text-base text-[#4A463F] leading-relaxed">
          The link you followed does not exist any more. Everything you need is one click away.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="btn-press inline-flex items-center justify-center rounded-2xl border border-[#1F1F1C]/25 px-7 py-4 font-semibold text-sm text-[#1F1F1C] hover:border-[#C8703A] hover:text-[#C8703A]"
            data-testid="not-found-home"
          >
            Back to home
          </Link>
          <AuditCta testId="not-found-audit" />
        </div>
      </div>
    </main>
  );
}
